import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { EChartsOption } from 'echarts';
import { NumberSuffixPipe } from 'src/app/core/filters/numberSuffix-pipe';

@Component({
  selector: 'app-sales-by-region-meritor-chart',
  templateUrl: './sales-by-region-meritor-chart.component.html',
  styleUrls: ['./sales-by-region-meritor-chart.component.scss']
})
export class SalesByRegionMeritorChartComponent implements OnInit {
  @Input() salesByRegion: any = {};
  @Input() legend: string = '';
  @Output() onLegendClick = new EventEmitter<any>();

  seriesData: any = [];
  title: string = '';
  echartsInstance: any;
  previousValue: string = '';
  count: number = 0;
  hideTotal: boolean = false;
  sum: number = 0;
  total1: number = 0;
  total2: number = 0;

  constructor() { }
  option: EChartsOption = {};
  ngOnInit(): void {
    this.seriesData = this.salesByRegion.map((name: any) => {
      return {
        name: name[this.legend],
        data: [name.prior_period_sales, name.current_period_sales],
      };
    });
    const total = {
      name: '',
      data: [0.01, 0.01],
    };
    this.seriesData.push(total);
    this.seriesData.forEach((item) => {
      this.total1 += item.data[0];
      this.total2 += item.data[1];
    });
    this.getChart();
  }

  genFormatter = (series) => {
    if (this.seriesData.length <= 2) {
      this.hideTotal = true;
    }
    return (param) => {
      this.sum = 0;
      series.forEach((item) => {
        this.sum += item.data[param.dataIndex];
      });
      this.sum = this.sum - 1;
      if (this.hideTotal == true) {
        return '';
      } else {
        return NumberSuffixPipe.prototype.transform(this.sum, 1);
      }
    };
  };
  valueFormatter() {
    return (param) => {
      if (param.dataIndex == 0) {
        if ((param.data / this.total1) * 100 < 3 && this.hideTotal !== true) {
          return '';
        } else {
          return NumberSuffixPipe.prototype.transform(param.value, 1);
        }
      } else {
        if ((param.data / this.total2) * 100 < 3 && this.hideTotal !== true) {
          return '';
        } else {
          return NumberSuffixPipe.prototype.transform(param.value, 1);
        }
      }
    };
  }
  isLastSeries(index) {
    return index == this.seriesData.length - 1;
  }

  isHidden(index, item) {
    if (item.data[0]) return index == this.seriesData.length - 1;
  }

  getChart() {
    this.hideTotal = false;
    switch (this.legend) {
      case 'country':
        this.title = 'Sales By Country';
        break;
      case 'ecc':
        this.title = 'Sales By DW-3-Digit Att';
        break;
      case 'ecc_major':
        this.title = 'Sales By DW-1-Digit Att';
        break;
      default:
    }
    this.option = {
      color: [
        '#118DFF',
        '#12239E',
        '#E66C37',
        '#6B007B',
        '#E044A7',
        '#744EC2',
        '#D9B300',
        '#D64550',
        '#197278',
        '#1AAB40',
        '#15C6F4',
        '#4092FF',
        '#FFA058',
        '#BE5DC9',
        '#F472D0',
        '#B5A1FF',
        '#895100',
        '#A4419C',
        '#0069B1',
        '#905CBB',
        '#7374D3',
        '#4D89E2',
        '#DE70A1',
        '#BD8B3E',
        '#39C08F',
        '#6C94BC',
        '#00B9EE',
        '#00C0F0',
        '#16E6B2',
        '#00E0E0',
        '#9EF389',
        '#F9F871',
        '#79FAC5',
        '#EEE8A9',
        '#D5F4FF',
        '#E6F4F1',

        '#a4e43f',
        '#d298e2',
        '#d2737d',
        '#651be6',
        '#79806e',
        '#61da5e',
        '#cd2f00',
        '#9348af',
        '#01ac53',
        '#c5a4fb',
        '#b11573',
        '#da967d',
        '#34891f',
        '#b0d87b',
        '#ca4751',
        '#7e50a8',
        '#c4d647',
        '#e0eeb8',
        '#11dec1',
        '#289812',
        '#566ca0',
        '#ffdbe1',
        '#2f1179',
        '#935b6d',
        '#916988',
        '#513d98',
        '#aead3a',
        '#9e6d71',
        '#4b5bdc',
        '#0cd36d',
        '#250662',
        '#cb5bea',
        '#228916',
        '#ac3e1b',
        '#df514a',
        '#539397',
        '#880977',
        '#f697c1',
        '#ba96ce',
        '#679c9d',
        '#c6c42c',
        '#5d2c52',
        '#48b41b',
        '#e1cf3b',
        '#5be4f0',
        '#57c4d8',
        '#a4d17a',
        '#225b8',
        '#be608b',
        '#96b00c',
        '#088baf',
        '#f158bf',
        '#e145ba',
        '#ee91e3',
        '#05d371',
        '#5426e0',
        '#4834d0',
        '#802234',
        '#6749e8',
        '#0971f0',
        '#8fb413',
        '#b2b4f0',
        '#c3c89d',
        '#c9a941',
        '#41d158',
        '#fb21a3',
        '#51aed9',
        '#5bb32d',
        '#807fb',
        '#21538e',
        '#89d534',
        '#d36647',
        '#7fb411',
        '#0023b8',
        '#3b8c2a',
        '#986b53',
        '#f50422',
        '#983f7a',
        '#ea24a3',
        '#79352c',
        '#521250',
        '#c79ed2',
        '#d6dd92',
        '#e33e52',
        '#b2be57',
        '#fa06ec',
        '#1bb699',
        '#6b2e5f',
        '#64820f',
        '#1c271',
        '#21538e',
        '#89d534',
        '#d36647',
        '#7fb411',
        '#0023b8',
        '#3b8c2a',
        '#986b53',
        '#f50422',
        '#983f7a',
        '#ea24a3',
        '#79352c',
        '#521250',
        '#c79ed2',
        '#d6dd92',
        '#e33e52',
        '#b2be57',
        '#fa06ec',
        '#1bb699',
        '#6b2e5f',
        '#64820f',
        '#1c271',
        '#9cb64a',
        '#996c48',
        '#9ab9b7',
        '#06e052',
        '#e3a481',
        '#0eb621',
        '#fc458e',
        '#b2db15',
        '#aa226d',
        '#792ed8',
        '#73872a',
        '#520d3a',
        '#cefcb8',
        '#a5b3d9',
        '#7d1d85',
        '#c4fd57',
        '#f1ae16',
        '#8fe22a',
        '#ef6e3c',
        '#243eeb',
        '#1dc18',
        '#dd93fd',
        '#3f8473',
        '#e7dbce',
        '#421f79',
        '#7a3d93',
        '#635f6d',
        '#93f2d7',
        '#9b5c2a',
        '#15b9ee',
        '#0f5997',
        '#409188',
        '#911e20',
        '#1350ce',
        '#10e5b1',
        '#fff4d7',
        '#cb2582',
        '#ce00be',
        '#32d5d6',
        '#17232',
        '#608572',
        '#c79bc2',
        '#00f87c',
        '#77772a',
        '#6995ba',
        '#fc6b57',
        '#f07815',
        '#8fd883',
        '#060e27',
        '#96e591',
        '#21d52e',
        '#d00043',
        '#b47162',
        '#1ec227',
        '#4f0f6f',
        '#947002',
        '#bde052',
        '#e08c56',
        '#28fcfd',
        '#bb09b',
        '#36486a',
        '#d02e29',
        '#1ae6db',
        '#3e464c',
        '#a84a8f',
        '#911e7e',
        '#3f16d9',
        '#0f525f',
        '#ac7c0a',
        '#b4c086',
        '#c9d730',
        '#30cc49',
        '#3d6751',
        '#fb4c03',
        '#640fc1',
        '#62c03e',
        '#d3493a',
        '#88aa0b',
        '#406df9',
        '#615af0',
        '#4be47',
        '#2a3434',
        '#4a543f',
        '#79bca0',
        '#a8b8d4',
        '#00efd4',
        '#7ad236',
        '#7260d8',
        '#1deaa7',
        '#06f43a',
        '#823c59',
        '#e3d94c',
        '#dc1c06',
        '#f53b2a',
        '#b46238',
        '#2dfff6',
        '#a82b89',
        '#1a8011',
        '#436a9f',
        '#1a806a',
        '#4cf09d',
        '#c188a2',
        '#67eb4b',
        '#b308d3',
        '#fc7e41',
        '#af3101',
        '#ff065',
        '#71b1f4',
        '#a2f8a5',
        '#e23dd0',
        '#d3486d',
        '#00f7f9',
        '#474893',
        '#3cec35',
        '#1c65cb',
        '#5d1d0c',
        '#2d7d2a',
        '#ff3420',
        '#5cdd87',
        '#a259a4',
        '#e4ac44',
        '#1bede6',
        '#8798a4',
        '#d7790f',
        '#b2c24f',
        '#de73c2',
        '#d70a9c',
        '#25b67',
        '#88e9b8',
        '#c2b0e2',
        '#86e98f',
        '#ae90e2',
        '#1a806b',
        '#436a9e',
        '#0ec0ff',
        '#f812b3',
        '#b17fc9',
        '#8d6c2f',
        '#d3277a',
        '#2ca1ae',
        '#9685eb',
        '#8a96c6',
        '#dba2e6',
        '#76fc1b',
        '#608fa4',
        '#20f6ba',
        '#07d7f6',
        '#dce77a',
        '#77ecca',
      ],

      title: {
        text: this.title,
        left: 'center',
        textStyle: {
          color: '#000000',
          fontSize: '14px',
        },
      },
      tooltip: {
        trigger: 'item',
        borderColor: 'white',
        backgroundColor: '#fafcfe',
        axisPointer: {
          type: 'shadow',
        },
        formatter: function (params: any) {
          let tar;
          let value;
          tar = params;
          if (params.seriesName == '') {
            return '';
          } else {
            value = params.value.toLocaleString(undefined, {
              minimumFractionDigits: 0,
              maximumFractionDigits: 0,
            });
            return tar.name + '<br/>' + tar.seriesName + ' : ' + value;
          }
        },
      },
      axisLabel: {
        align: 'center',
        fontSize: 12,
      },
      legend: {
        type: 'scroll',
        orient: 'vertical',
        top: '50',
        left: '0%',
        icon: 'circle',
        itemWidth: 10,
        itemHeight: 10,
        textStyle: {
          fontSize: '9px',
        },
      },

      grid: {
        left: '17%',
        right: '4%',
        bottom: '3%',
        containLabel: true,
      },
      xAxis: [
        {
          type: 'category',

          data: ['2025', '2026'],
        },
      ],
      yAxis: [
        {
          type: 'value',
          show: false,
        },
      ],
      series: this.seriesData.map((item, index) =>
        Object.assign(item, {
          type: 'bar',
          stack: true,
          barWidth: 50,
          labelLayout: {
            hideOverlap: this.isLastSeries(index) ? false : true,
          },
          label: {
            show: true,
            formatter: this.isLastSeries(index)
              ? this.genFormatter(this.seriesData)
              : this.valueFormatter(),
            fontSize: this.isLastSeries(index) ? 12 : 11,
            fontWeight: this.isLastSeries(index) ? 700 : 300,
            position: this.isLastSeries(index) ? 'top' : 'inside',
            color: this.isLastSeries(index) ? 'black' : 'white',
          },
        })
      ),
    };
  }
  onChartInit(e: any) {
    this.echartsInstance = e;
  }
  barChange(params) {
    if (params.seriesName != '') {
      let selected = {};
      this.seriesData.map((item: any) => {
        if (item.name == params.seriesData) {
          selected[item.name] = false;
        } else {
          selected[item.name] = true;
        }
      });
      let legend = {
        name: params.seriesName,
        selected: selected,
        type: 'legendselectchanged',
      };
      this.selectGraph(legend);
      this.unselectGrap(legend);
    }
  }
  legendChange(params) {
    this.selectGraph(params);
    this.unselectGrap(params);
  }

  selectGraph(params) {
    this.echartsInstance.dispatchAction({
      type: 'legendSelect',
      name: params.name,
    });
  }

  unselectGrap(params) {
    if (this.previousValue == params.name && this.count == 0) {
      this.onLegendClick.emit('All');
      this.getChart();
      this.count = 1;
    } else {
      for (const legend in params.selected) {
        if (legend !== params.name) {
          this.hideTotal = true;
          this.echartsInstance.dispatchAction({
            type: 'legendUnSelect',
            name: legend,
          });
        }
        this.count = 0;
      }
      this.onLegendClick.emit(params.name);
    }
    this.previousValue = params.name;
  }
  reset() {
    this.getChart();
  }
}
